import React from 'react';

import { Box, Button } from '@mui/material';
import { DataGrid, GridRowSelectionModel } from '@mui/x-data-grid';

import GridPagination from '~/components/Common/Elements/GridPagination';
import columns, { BlockedOfferRow } from '~/components/Marketing/OfferBlocklist/columns';

interface Props {
  rows: Array<BlockedOfferRow>;
  isLoading: boolean;
  page: number;
  sizePerPage: number;
  rowCount: number;
  selected: GridRowSelectionModel;
  onPageChange: (page: number) => void;
  onSelect: (selectedIds: GridRowSelectionModel) => void;
  onRemoveSelected: () => void;
}

export default function BlockedOffersGrid({
  rows,
  isLoading,
  page,
  sizePerPage,
  rowCount,
  selected,
  onPageChange,
  onSelect,
  onRemoveSelected,
}: Props) {
  return (
    <Box mt={2}>
      <Button disabled={selected.length === 0} onClick={onRemoveSelected}>
        Remove Selected offers
      </Button>

      <DataGrid
        columns={columns}
        checkboxSelection
        className="T-offers-table"
        rows={rows}
        pagination
        paginationMode="server"
        paginationModel={{ page: page - 1, pageSize: sizePerPage }}
        slots={{ pagination: GridPagination }}
        pageSizeOptions={[sizePerPage]}
        onPaginationModelChange={({ page }) => onPageChange(page + 1)}
        loading={isLoading}
        getRowId={(row: BlockedOfferRow) => row.offerId}
        getRowHeight={() => 'auto'}
        onRowSelectionModelChange={onSelect}
        rowSelectionModel={selected}
        sx={{ '.MuiDataGrid-cell': { alignItems: 'start' } }}
        rowCount={rowCount}
        disableRowSelectionOnClick
        disableColumnMenu
        autoHeight
      />
    </Box>
  );
}
